export var MOBILE_INIT = 'MOBILE_INIT';
export var init = function init(urn) {
  return {
    type: MOBILE_INIT,
    payload: {
      urn: urn
    }
  };
};